import { IconName } from '../components/icon/icon.component';
import { PROJEKT_REITER_GRUPPEN } from '../projects/project-nav/project-nav.component';
import { TestCaseLinkType } from '../models/test-case-link.model';

export type LinkTypeIcon =
  | { kind: 'app-icon'; name: IconName }
  | { kind: 'fa'; cls: string }
  | { kind: 'mat'; name: string };

export interface LinkTypeMeta {
  icon: LinkTypeIcon;
  color: string;
  filled: boolean;
}

function reiterIcon(reiterId: string): LinkTypeIcon {
  const reiter = PROJEKT_REITER_GRUPPEN.flatMap((gruppe) => gruppe.reiter).find((r) => r.id === reiterId);
  if (!reiter) {
    throw new Error(`Projekt-Reiter ${reiterId} fehlt`);
  }
  return { kind: 'app-icon', name: reiter.icon };
}

export const LINK_TYPE_META: Readonly<Record<TestCaseLinkType, LinkTypeMeta>> = {
  REQUIREMENT: { icon: reiterIcon('requirements'), color: 'var(--tf-accent)', filled: false },
  TESTCASE: { icon: reiterIcon('test-cases'), color: 'var(--tf-accent)', filled: false },
  JIRA: { icon: { kind: 'fa', cls: 'fa-brands fa-jira' }, color: 'var(--tf-brand-jira)', filled: true },
  GITHUB: { icon: { kind: 'fa', cls: 'fa-brands fa-github' }, color: 'var(--tf-brand-github)', filled: false },
  URL: { icon: { kind: 'mat', name: 'link' }, color: 'var(--tf-text-muted)', filled: false },
};
